import { useCallback, useState } from 'react';

export function usePersistedBoolean(key: string, defaultValue: boolean) {
  const [value, setValue] = useState<boolean>(() => {
    try {
      const stored = localStorage.getItem(key);
      return stored !== null ? stored === 'true' : defaultValue;
    } catch {
      return defaultValue;
    }
  });
  const set = useCallback(
    (updater: boolean | ((prev: boolean) => boolean)) => {
      setValue((prev) => {
        const next = typeof updater === 'function' ? updater(prev) : updater;
        try {
          localStorage.setItem(key, String(next));
        } catch (_e) {
          // ignore storage errors
        }
        return next;
      });
    },
    [key],
  );
  return [value, set] as const;
}
